export default "__VITE_ASSET__Dq6jq7jV__"